import { faBolt, faChartSimple, faCrosshairs, faShield, faUsers } from '@fortawesome/pro-regular-svg-icons';

export const formName = 'ttx';

export const notLoggedInFormId = 'd66493d8-a98f-4a86-b1c7-0561f38ce01e';

const commonBenefits = [
  {
    icon: faCrosshairs,
    text: 'Spot vulnerabilities before they spread',
  },
  {
    icon: faChartSimple,
    text: 'Validate response plans under pressure',
  },
  {
    icon: faUsers,
    text: 'Strengthen collaboration across roles',
  },
  {
    icon: faShield,
    text: 'Turn discussion into actionable improvements',
  },
];

export const loggedInBenefits = [
  {
    icon: faBolt,
    text: 'Simulate realistic incidents safely',
  },
  ...commonBenefits,
];

export const loggedOutBenefits = [
  ...commonBenefits,
  {
    icon: faBolt,
    text: 'Launch tailored exercises instantly',
  },
];

// to create a custom css for hubspot form we need to pass it as a string with hubspot classes
export const hsCss = `
  .hs-button {
    margin-top: 30px;
    background-color: rgba(163, 234, 42, 1);
    color: rgba(21, 28, 43, 1);
    padding: 10px 16px 10px 16px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid rgba(163, 234, 42, 1);
    font-family: Ubuntu;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    cursor: pointer;

    @media screen and (min-width: 481px) {
      margin-top: 46px;
    }
  }

  .hs-button:hover {
    background-color: rgba(163, 234, 42, 0.3);
    color: rgb(249, 249, 251);
  }

  .hs-input {
    height: 36px;
    border-radius: 5px;
    border: 1px solid rgba(62, 71, 90, 1);
    background-color: rgba(21, 28, 43, 1);
    color: white;
    outline: none;
  }

  .hs-input.invalid {
    border-color: rgba(255, 91, 103, 1);
    background-color: rgba(255, 91, 103, 0.1);
  }

  .hs-error-msg {
    color: rgba(255, 91, 103, 1);
    font-size: 1.2rem;
  }

  .hs-input::placeholder {
    color: rgba(135, 143, 162, 1);
    font-family: Source Sans Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
  }

  .hs-input:focus-within {
    border-color: rgba(113, 156, 249, 1);
  }

  .hs-fieldtype-text {
    font-family: Source Sans Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(249, 249, 251, 1);
  }

  div.input {
    margin-right: 0 !important;
  }

  select.hs-input {
    font-family: Source Sans Pro;
    color: rgba(135, 143, 162, 1);
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    padding-left: 10px;
    appearance: none;
  }

  .hs-fieldtype-select {
    font-family: Source Sans Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(249, 249, 251, 1);
  }

  .hs-form-required {
    color: rgba(255, 91, 103, 1);
  }

  .hs-firstname {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input {
        width: 100%;
    }
  }

  .form-columns-2 {
    @media screen and (min-width: 481px) {
      display: flex;
      gap: 16px;
    }
  }

  .hs-lastname {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    @media screen and (min-width: 481px) {
      margin-top: 0;
    }
  }

  .hs-email {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .hs-company {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    input {
        width: 100%;
    }
  }

  .hs-recaptcha {
    margin-top: 32px;
  }

  .hs-seats_required {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .hs-job_role {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .hs-more_details {
    margin: 32px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-family: Source Sans Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(249, 249, 251, 1);
  }

  .hs-fieldtype-textarea {
    height: 56px;
  }

  .hs_recaptcha {
    display: none;
  }

  #label-lastname-1cb97f42-882e-43ab-bbc5-99c4cb17f6c3 {
    @media screen and (min-width: 481px) {
      margin-top: 32px;
    }
  }
`;
